export const UserInfoService = Symbol('UserInfoService');

export interface UserInfoService {
    getIsEnterpriseTenant(): Promise<boolean>;
    getIsPersonalTenant(): Promise<boolean>;
    getIsFreeUser(): Promise<boolean>;
    getIsPro(): Promise<boolean>;
    getIsFeiShu(): Promise<boolean>;
    getIsCreditsAvailable(): Promise<boolean>;
    getIsCountPackageAvailable(): Promise<boolean>;
    getIsEnterpriseCommercialUser(): Promise<boolean>;
    getIsEnterpriseFreeUser(): Promise<boolean>;
    getIsTrialUser(): Promise<boolean>;
}
